<template>
    <div v-if="contact" id="shortcut" class="shortcut-wrapper" @mouseout.prevent="contact.contentType == 'textarea' ?  slideOut(false): slideOut(true)"  @mouseover.prevent="contact.contentType == 'textarea' ? slideIn(false) : slideIn(true)">
        <button class="text-xs-center contact-button anti-rotate-center">
            <span @click.prevent="contact.contentType == 'textarea' ? toChat(contact): null" class="v-chip pointer semi-transparent-7-bg">
                    <span class="pointer v-chip__content">
                        <div class="v-avatar">
                            <img class="rotate" :src="contact.avatar" :alt="contact.name">
                        </div>
                        {{  contact.name }}
                    </span>
            </span>
        </button>
        <ul class="contact-img">
            <li :style="{ backgroundImage: `url(${contact.script})` }">
                <!-- <img class="thumbnail" :src="contact.script"/> -->
            </li>
        </ul>
    </div>
</template>

<style scoped>
.shortcut-wrapper {
    position: fixed;
    left: -178px;
    height: 1px;
    top: 60%;
    transition: all 0.3s ease 0s;
    z-index: 999999;
}
.anti-rotate {
    -webkit-transform: rotate(-90deg);
    -webkit-transform-origin: left top;
    -moz-transform: rotate(-90deg);
    -moz-transform-origin: left top;
    -ms-transform: rotate(-90deg);
    -ms-transform-origin: left top;
    -o-transform: rotate(-90deg);
    -o-transform-origin: left top;
    transform: rotate(-90deg);
    transform-origin: left top;
}

.anti-rotate-center {
    -webkit-transform: rotate(-90deg);
    -webkit-transform-origin: left top;
    -moz-transform: rotate(-90deg);
    -moz-transform-origin: left top;
    -ms-transform: rotate(-90deg);
    -ms-transform-origin: left top;
    -o-transform: rotate(-90deg);
    -o-transform-origin: left top;
    transform: rotate(-90deg);
    transform-origin: left top;
}

.contact-button {
    background-color: transparent;
    border: none;
    outline: none;
    padding: 0;
    cursor: pointer;
    z-index: 999999;
}

.contact-img {
    border-radius: 0px 0px 15px 0px;
    float: left;
    list-style: none;
    padding: 0;
    margin: 0;
    margin-left: 10px;
    -webkit-transform: translateY(-60%);
    transform: translateY(-60%);
}

.contact-img li {
    color: #fff;
    width: 168px;
    height: 168px;
    text-align: center;
    border-radius: 0px 0px 15px 0px;
    background-position: center center;
    background-size: contain;
    background-repeat: no-repeat;
    animation: glow .8s infinite alternate;
    background-color: #f0f8ff2b;
}

.contact-img li img {
    max-width: 100%;
    height: 100%;
    box-sizing: border-box;
    border-radius: 0px 0px 15px 0px;

}

.rotate {
    -webkit-transform: rotate(90deg);
    -webkit-transform-origin: center;
    -moz-transform: rotate(90deg);
    -moz-transform-origin: center;
    -ms-transform: rotate(90deg);
    -ms-transform-origin: center;
    -o-transform: rotate(90deg);
    -o-transform-origin: center;
    transform: rotate(90deg);
    transform-origin: center;
}
.pointer {
    cursor: pointer!important;
}


.v-avatar {
    -webkit-filter: drop-shadow(0px 1px 0px white) drop-shadow(1px 0px 0px white);
    filter: drop-shadow(0px 1px 0px white) drop-shadow(1px 0px 0px white);
}

.v-chip {
    animation: glow-transparent .8s infinite alternate;
    margin:2px 0 0 0!important;
}

@keyframes glow {
    to {
        -webkit-filter: drop-shadow(0px 1px 1px rgb(253, 253, 255, 0.7)) drop-shadow(1px 0px 1px rgb(253, 253, 255, 0.7)) drop-shadow(-1px -1px 1px rgb(253, 253, 255, 0.7));
        filter: drop-shadow(0px 1px 1px rgb(253, 253, 255. 0.7)) drop-shadow(1px 0px 1px rgb(253, 253, 255. 0.7)) drop-shadow(-1px -1px 1px rgb(253, 253, 255, 0.7));
    }
}

@keyframes glow-transparent {
    to {
         opacity: 0.7;
        -webkit-filter: drop-shadow(0px 1px 1px rgb(253, 253, 255, 0.7)) drop-shadow(1px 0px 1px rgb(253, 253, 255, 0.7)) drop-shadow(-1px -1px 1px rgb(253, 253, 255, 0.7));
        filter: drop-shadow(0px 1px 1px rgb(253, 253, 255. 0.7)) drop-shadow(1px 0px 1px rgb(253, 253, 255. 0.7)) drop-shadow(-1px -1px 1px rgb(253, 253, 255, 0.7));
    }
}


</style>

<script>
export default {
    props: ["shortcut"],
    data() {
        return {
        }
    },
    computed: {
        contact: function() {
            if(this.$store.getters.system_contactus) {
                let contact = this.$store.getters.system_contactus;
                contact['avatar'] = this.getImgUrl(contact['type'].toLowerCase());
                return contact;
            } else {
                return null;
            }
        }
    },
    methods: {
        getImgUrl(contact) {
            var images = require.context('@/assets/contact/', false, /\.png$/);
            return images('./' + contact + ".png");
        },
        toChat(data) {
            if (data['script']) {
                window.open(data['script']);
            } else{
                switch(data['type']) {
                    case 'phone':
                        window.open('tel:' + data['contact']);
                        break;
                    case 'facebook':
                        // fb://page/<id_here>
                        window.open(data['contact'], '_system');
                        break;
                    case 'instagram':
                        window.open('instagram://user?username=' + data['contact']);
                        // 'instagram://user?username=<username>;
                        break;
                    case 'line':
                        window.open('line://ti/p/@' + data['contact']);
                        // "line://ti/p/@UserlineID"
                        break;
                    case 'skype':
                        // skype:some_skype_user?chat'
                        window.open('skype:' + data['contact'] + '?chat');
                        break;
                    case 'telegram':
                        // https://t.me/USERNAME
                        window.open('https://t.me/' + data['contact']);
                        break;
                    case 'wechat':
                        // weixin://dl/chat?{toID}
                        window.open('weixin://dl/chat?' + data['contact']);
                        break;
                    case 'whatsapp':
                        // whatsapp://send?text=The text to share!
                        window.open('whatsapp://send?text=Hi%2C%20I%20am%20interested&phone=' + data['contact']);
                        break;
                    case 'twitter':
                        // twitter://user?screen_name=<page>
                        window.open('twitter://user?screen_name=' + data['contact']);
                        break;
                    case 'zalo':
                        // http://zaloapp.com/qr/p/{UserID}
                        window.open('http://zaloapp.com/qr/p/' + data['contact']);
                        break;
                    default:
                        break;
                }
            }
        },
        slideIn(condition) {
            if(condition) {
                let el = document.getElementById('shortcut');
                el.style.left='-10px';
            }
        },
        slideOut(condition) {
            if(condition) {
                let el = document.getElementById('shortcut');
                el.style.left='-178px';
            }
        }
    }
}
</script>
